import React from "react";
import Breadcrumbs from "@/components/Breadcrumbs";
import { hero } from "@/lib/images";

const ImageHero = ({ image, alt, eyebrow, titleA, titleB, text, crumbs, children, tall = false, testId = "image-hero", titleTestId }) => (
  <section data-testid={testId} className={`relative flex items-end overflow-hidden bg-slate-900 ${tall ? "min-h-[88vh]" : "min-h-[62vh]"}`}>
    <img src={hero(image)} alt={alt || `${titleA || ""} ${titleB || ""}`.trim()} className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/45 to-slate-950/30" />
    <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-16 sm:pb-24">
      {crumbs && <Breadcrumbs items={crumbs} light />}
      {eyebrow && <p className={`eyebrow !text-stone-300 fade-up ${crumbs ? "mt-8" : ""}`}>{eyebrow}</p>}
      <h1
        data-testid={titleTestId}
        className="font-serif mt-6 text-4xl sm:text-5xl lg:text-6xl font-light text-stone-50 leading-[1.05] max-w-4xl fade-up fade-up-delay-1"
      >
        {titleA}
        {titleB && (
          <>
            {" "}
            <br />
            <span className="italic text-stone-300">{titleB}</span>
          </>
        )}
      </h1>
      {text && <p className="mt-8 text-stone-200 text-base md:text-lg leading-relaxed max-w-2xl fade-up fade-up-delay-2">{text}</p>}
      {children && <div className="mt-10 flex flex-col sm:flex-row gap-4 fade-up fade-up-delay-3">{children}</div>}
    </div>
  </section>
);

export default ImageHero;
